module.exports = __webpack_public_path__ + "img/20220624174142.723a2c99.png";